export default __webpack_public_path__ + "static/media/Mflix_Header.7beeb910.gif";